(function () {
  function getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  function renderSections(sections) {
    const cartDrawerEl = document.querySelector('cart-drawer');
    if (cartDrawerEl && sections['cart-drawer']) {
      const drawerInner = cartDrawerEl.querySelector('.drawer__inner');
      if (drawerInner) {
        drawerInner.innerHTML = getSectionInnerHTML(sections['cart-drawer'], '.drawer__inner');
      }
      cartDrawerEl.classList.remove('is-empty');
    }
    const bubble = document.getElementById('cart-icon-bubble');
    if (bubble && sections['cart-icon-bubble']) {
      bubble.innerHTML = getSectionInnerHTML(sections['cart-icon-bubble'], '.shopify-section');
    }
  }

  function openCartDrawer() {
    const drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.open === 'function') {
      drawer.open();
    }
  }

  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.cart-drawer__crosssell-add');
    if (!btn) return;
    e.preventDefault();
    if (btn.disabled) return;

    const variantId = btn.dataset.variantId;
    if (!variantId) return;

    btn.disabled = true;
    const originalText = btn.textContent;
    btn.textContent = '...';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
      body: JSON.stringify({
        items: [{ id: parseInt(variantId, 10), quantity: 1 }],
        sections: ['cart-drawer', 'cart-icon-bubble'],
        sections_url: window.location.pathname
      })
    })
      .then((r) => {
        if (!r.ok) throw new Error('add failed');
        return r.json();
      })
      .then((data) => {
        if (data.sections) renderSections(data.sections);
        openCartDrawer();
      })
      .catch(() => {
        btn.disabled = false;
        btn.textContent = originalText;
      });
  });
})();
